import { render, staticRenderFns } from "./StudySetEditFooter.vue?vue&type=template&id=d0fa395c&scoped=true&"
import script from "./StudySetEditFooter.vue?vue&type=script&lang=js&"
export * from "./StudySetEditFooter.vue?vue&type=script&lang=js&"
import style0 from "./StudySetEditFooter.vue?vue&type=style&index=0&id=d0fa395c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0fa395c",
  null
  
)

export default component.exports